import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
import { CFormSwitch, CFormLabel, CForm, CFormInput, CButton, CNav, CNavItem, CNavLink, CTabContent, CTabPane } from '@coreui/react';
import PECopy from './PECopy';
import GetDiagnosisData from '../../services/general/getDiagnosisData.api';

const typeOptions = [
    { value: 'accordion', label: 'Accordion' },
    { value: 'header', label: 'Header' },
    { value: 'subHeader', label: 'Sub Header' },
    { value: 'option', label: 'Option' },
    { value: 'title', label: 'Title' },

];

const hierarchyTypeOptions = [
    { value: 'single', label: 'Single' },
    { value: 'multi', label: 'Multi' },
    { value: 'input', label: 'Input' }
];

const PEAddEditModel = ({ handleSave, editFormData, isEdit, type, onCloseModule, parentID, childID, showCopy = true, showType = true, showHierarchyType = true, apiType, useDiagnosisNameSelect = false }) => {
    const [formData, setFormData] = useState({
        id: Date.now(),
        name: '',
        type: type || '',
        alert: '',
        isHierarchy: false,
        hierarchyType: '',
        hierarchy: [],
        alert: '',
        education: [],
        inputData: '',
        rowAlign: false,
        isSelected: false,
        inNote: true,
        isNewLine: false
    });

    const [typeSelect, setTypeSelect] = useState(null);
    const [activeTab, setActiveTab] = useState('add');
    const [diagnosisOptions, setDiagnosisOptions] = useState([]);
    const [theme, setTheme] = useState(() => {
        if (typeof document === 'undefined') return 'dark';
        return document.documentElement.getAttribute('data-theme') || document.body.getAttribute('data-theme') || 'dark';
    });


    useEffect(() => {
        if (editFormData) {
            setFormData(editFormData);
            setTypeSelect(typeOptions.find(option => option.value === editFormData.type) || null);
        } else {
            setTypeSelect(typeOptions.find(option => option.value === type) || null);
        }
    }, [editFormData, type]);

    useEffect(() => {
        if (!useDiagnosisNameSelect) return;

        const getDiagnosisOptions = async () => {
            try {
                const response = await GetDiagnosisData('');
                const diagnosis = JSON.parse(response.d)?.Data || [];
                const options = diagnosis
                    .map((item) => ({
                        value: item.Name,
                        label: item.Name,
                    }))
                    .filter((item) => item.value)
                    .sort((a, b) => a.label.toLocaleLowerCase().trim().localeCompare(b.label.toLocaleLowerCase().trim()));

                setDiagnosisOptions(options);
            } catch (error) {
                console.log('Error loading diagnosis options', error);
            }
        };

        getDiagnosisOptions();
    }, [useDiagnosisNameSelect]);

    useEffect(() => {
        if (!useDiagnosisNameSelect || typeof window === 'undefined') return;

        const handleThemeChange = () => {
            setTheme(document.documentElement.getAttribute('data-theme') || document.body.getAttribute('data-theme') || 'dark');
        };

        window.addEventListener('provio-theme-change', handleThemeChange);
        return () => {
            window.removeEventListener('provio-theme-change', handleThemeChange);
        };
    }, [useDiagnosisNameSelect]);

    const handleSelectChange = (selectedOption, field) => {
        setFormData(prev => ({ ...prev, [field]: selectedOption?.value || '' }));
    };

    const handleSwitchChange = () => {
        setFormData(prev => ({ ...prev, rowAlign: !prev.rowAlign }));
    };
    const handleSelectedChange = () => {
        setFormData(prev => ({ ...prev, isSelected: !prev.isSelected }));
    }

    const handleInNoteChange = () => {
        setFormData(prev => ({ ...prev, inNote: !prev.inNote }));
    }
    const handleNewLine = () => {
        setFormData(prev => ({ ...prev, isNewLine: !prev.isNewLine }));
    }
    const handleInputChange = (e) => {
        setFormData(prev => ({ ...prev, name: e.target.value }));
    };

    const selectedDiagnosisName = formData.name ? { value: formData.name, label: formData.name } : null;
    const isLightTheme = theme === 'light';
    const diagnosisSelectStyles = {
        control: (base, state) => ({
            ...base,
            backgroundColor: isLightTheme ? '#ffffff' : 'var(--ui-bg-inset, #1b1b1b)',
            borderColor: state.isFocused ? 'var(--ui-color-primary, #2b7cd3)' : isLightTheme ? '#ced4da' : 'var(--ui-dashboard-border-strong, #3a3a3a)',
            boxShadow: state.isFocused ? '0 0 0 1px var(--ui-color-primary, #2b7cd3)' : 'none',
            color: isLightTheme ? '#212529' : 'var(--ui-text-primary, #ffffff)',
            '&:hover': {
                borderColor: 'var(--ui-color-primary, #2b7cd3)',
            },
        }),
        menu: (base) => ({
            ...base,
            backgroundColor: isLightTheme ? '#ffffff' : 'var(--ui-bg-elevated, #222222)',
            border: `1px solid ${isLightTheme ? '#ced4da' : 'var(--ui-dashboard-border-strong, #3a3a3a)'}`,
            overflow: 'hidden',
        }),
        menuList: (base) => ({
            ...base,
            backgroundColor: isLightTheme ? '#ffffff' : 'var(--ui-bg-elevated, #222222)',
        }),
        option: (base, state) => ({
            ...base,
            backgroundColor: state.isSelected
                ? 'var(--ui-color-primary, #2b7cd3)'
                : state.isFocused
                    ? (isLightTheme ? '#f1f5f9' : 'var(--ui-bg-hover, #2a2a2a)')
                    : (isLightTheme ? '#ffffff' : 'var(--ui-bg-elevated, #222222)'),
            color: state.isSelected ? '#ffffff' : isLightTheme ? '#212529' : 'var(--ui-text-primary, #ffffff)',
            cursor: 'pointer',
            '&:active': {
                backgroundColor: state.isSelected ? 'var(--ui-color-primary, #2b7cd3)' : isLightTheme ? '#e9ecef' : 'var(--ui-bg-hover, #2a2a2a)',
            },
        }),
        placeholder: (base) => ({
            ...base,
            color: isLightTheme ? '#6c757d' : 'var(--ui-text-placeholder, #94a3b8)',
        }),
        singleValue: (base) => ({
            ...base,
            color: isLightTheme ? '#212529' : 'var(--ui-text-primary, #ffffff)',
        }),
        input: (base) => ({
            ...base,
            color: isLightTheme ? '#212529' : 'var(--ui-text-primary, #ffffff)',
        }),
        dropdownIndicator: (base) => ({
            ...base,
            color: isLightTheme ? '#6c757d' : 'var(--ui-text-secondary, #d1d5db)',
        }),
        clearIndicator: (base) => ({
            ...base,
            color: isLightTheme ? '#6c757d' : 'var(--ui-text-secondary, #d1d5db)',
        }),
        indicatorSeparator: (base) => ({
            ...base,
            backgroundColor: isLightTheme ? '#ced4da' : 'var(--ui-dashboard-border-strong, #3a3a3a)',
        }),
        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    };



    const handleSaveOrEditData = () => {
        if (isEdit && formData.id) {
            handleSave(formData, formData.id);
        } else {
            handleSave(formData);
        }
        setFormData({
            name: '',
            type: '',
            alert: '',
            isHierarchy: false,
            hierarchyType: '',
            hierarchy: []
        });
        onCloseModule()
    };

    const handleClose = () => {
        setFormData({
            name: '',
            type: '',
            alert: '',
            isHierarchy: false,
            hierarchyType: '',
            hierarchy: []
        })
        onCloseModule()
    };



    return (
        <div className="p-1 pe-add-edit-modal-wrapper">
            {showType && <CNav variant="pills" role="tablist" className="justify-content-center pe-side-panel__nav" style={{ marginBottom: '10px' }}>
                <CNavItem>
                    <CNavLink active={activeTab === 'add'} onClick={() => setActiveTab('add')}>Add</CNavLink>
                </CNavItem>
                <CNavItem>
                    <CNavLink className={`${showCopy ? '' : 'disabled'}`} active={activeTab === 'copy'} onClick={() => setActiveTab('copy')}>Copy</CNavLink>
                </CNavItem>
            </CNav>}
            <CTabContent>
                <CTabPane visible={activeTab === 'add'}>
                    <CForm>
                        <div className="mb-3">
                            <CFormLabel>Name</CFormLabel>
                            {useDiagnosisNameSelect ? (
                                <CreatableSelect
                                    className="basic-single-select ui-react-select"
                                    classNamePrefix="select"
                                    value={selectedDiagnosisName}
                                    options={diagnosisOptions}
                                    onChange={(selected) => {
                                        setFormData(prev => ({ ...prev, name: selected?.label || '' }));
                                    }}
                                    onCreateOption={(inputValue) => {
                                        setFormData(prev => ({ ...prev, name: inputValue }));
                                    }}
                                    isClearable
                                    formatCreateLabel={(inputValue) => `Add "${inputValue}"`}
                                    menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
                                    styles={diagnosisSelectStyles}
                                />  
                            ) : (
                                <CFormInput type="text" placeholder="Enter Name" value={formData.name} onChange={handleInputChange} />
                            )}
                        </div>
                        {showType && <div className="mb-3">
                            <CFormLabel>Type</CFormLabel>
                            <Select
                                className="basic-single-select ui-react-select"
                                classNamePrefix="select"
                                value={typeSelect}
                                options={typeOptions}
                                onChange={(selected) => {
                                    setTypeSelect(selected);
                                    handleSelectChange(selected, 'type');
                                }}
                                isClearable
                            />
                        </div>}
                        {showHierarchyType && <div className="mb-3">
                            <CFormLabel>Hierarchy Type</CFormLabel>
                            <Select
                                className="basic-single-select ui-react-select"
                                classNamePrefix="select"
                                value={hierarchyTypeOptions.filter((HType) => HType.value === formData.hierarchyType)}
                                options={hierarchyTypeOptions}
                                onChange={(selected) => handleSelectChange(selected, 'hierarchyType')}
                                isClearable
                            />
                        </div>}
                        {showType && <div className=' mb-3 d-flex justify-content-start gap-4 '>
                            <div className=" ">
                                <CFormLabel htmlFor="rowAlignSwitch">Row Align</CFormLabel>
                                <CFormSwitch id="rowAlignSwitch" className="pe-custom-switch"  checked={Boolean(formData.rowAlign)} onChange={handleSwitchChange} />
                            </div>
                            {/* <div className=" ">
                                <CFormLabel htmlFor="isNewLineSwitch">New Line </CFormLabel>
                                <CFormSwitch id="isNewLineSwitch" className="pe-custom-switch" checked={Boolean(formData.isNewLine)} onChange={handleNewLine} />
                            </div> */}
                            <div className=" ">
                                <CFormLabel htmlFor="isSelectedSwitch">Default Value</CFormLabel>
                                <CFormSwitch id="isSelectedSwitch" className="pe-custom-switch" checked={Boolean(formData.isSelected)} onChange={handleSelectedChange} />
                            </div>

                        </div>}
                        {/* {showType && <div className=" ">
                            <CFormLabel htmlFor="inNoteSwitch">Show in note</CFormLabel>
                            <CFormSwitch id="inNoteSwitch" className="pe-custom-switch" checked={Boolean(formData.inNote)} onChange={handleInNoteChange} />
                        </div>} */}
                        <div className="d-flex justify-content-end mt-3">
                            <CButton color="secondary" onClick={handleClose} className="ui-action-btn ui-action-btn--secondary me-2">Close</CButton>
                            <CButton color="primary" onClick={() => { handleSaveOrEditData() }} className="ui-action-btn ui-action-btn--primary">Save</CButton>
                        </div>
                    </CForm>
                </CTabPane>
                <CTabPane visible={activeTab === 'copy'} className='' style={{ height: '400px', maxHeight: '600px', overflow: 'auto' }}>
                    {/* <p>Copy functionality will be implemented here.</p> */}
                    <PECopy parentID={parentID} childID={childID} handleSave={handleSave} apiType={apiType} />
                </CTabPane>
            </CTabContent>
        </div>
    );
};

export default PEAddEditModel;
